/**
 * iter-121.47 — Gallery redesign.
 *
 * Four KPI tiles at the top of the Gallery page (Total / Visuals /
 * Tables / Insights). Click a tile to filter the list to that group.
 * Selection state lives in the parent so the URL stays clean.
 */
import React from "react";
import { Boxes, BarChart3, Table2, Sparkles } from "lucide-react";

const STAT_DEFS = [
    {
        key: "all",
        label: "Total assets",
        icon: Boxes,
        // soft tinted bg + matching foreground for the icon plate
        plate: "bg-violet-100 text-violet-600",
    },
    {
        key: "visual",
        label: "Visuals",
        icon: BarChart3,
        plate: "bg-emerald-100 text-emerald-600",
        kinds: ["kpi", "chart"],
    },
    {
        key: "table",
        label: "Tables",
        icon: Table2,
        plate: "bg-sky-100 text-sky-600",
        kinds: ["table"],
    },
    {
        key: "insight",
        label: "Insights",
        icon: Sparkles,
        plate: "bg-amber-100 text-amber-600",
        kinds: ["insight"],
    },
];

function countFor(items, def) {
    if (def.key === "all") return items.length;
    return items.filter((i) => def.kinds.includes(i.kind)).length;
}

export default function GalleryStatsCards({ items, activeStat, onSelectStat }) {
    return (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-5" data-testid="gallery-stats">
            {STAT_DEFS.map((def) => {
                const Icon = def.icon;
                const count = countFor(items, def);
                const active = activeStat === def.key;
                return (
                    <button
                        key={def.key}
                        type="button"
                        onClick={() => onSelectStat(def.key)}
                        className={`group flex items-center justify-between rounded-xl border bg-card px-4 py-4 text-left shadow-sm transition-all hover:shadow-md ${
                            active ? "border-foreground/30 ring-1 ring-foreground/10" : "border-border hover:border-foreground/20"
                        }`}
                        data-testid={`gallery-stat-${def.key}`}
                        aria-pressed={active}
                    >
                        <div className="min-w-0">
                            <div className="text-xs font-medium text-muted-foreground">{def.label}</div>
                            <div className="mt-1 text-2xl font-semibold tabular-nums">{count}</div>
                        </div>
                        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${def.plate}`}>
                            <Icon className="h-5 w-5" strokeWidth={1.75} />
                        </div>
                    </button>
                );
            })}
        </div>
    );
}

export { STAT_DEFS };
